module.exports = __webpack_public_path__ + "media/components/footer/static/wfc--white-bd30cbc02abcdeb57bbab1db59af61d0.svg";